<template>
	<div>
		<label
			:for="$attrs.id?$attrs.id:$fid('vspaginationlengthcustom')"
			class="m-auto mr-2 ml-0"
		>{{title}}</label>
		<vs-dropdown
			v-show="tableProvider && tableProvider.pageLengths"
			:id="$attrs.id?$attrs.id:$fid('vspaginationlengthcustom')"
			ref='dropdown'
			vs-trigger-click
			:disabled="backendOcupado || (tableProvider ? tableProvider.busy : false)"
			:class="[
				{'cursor-pointer' : (! backendOcupado && (! tableProvider || !tableProvider.busy))},
				{'cursor-not-allowed' : backendOcupado || (tableProvider ? tableProvider.busy : false)},
				{'disabled' : backendOcupado || (tableProvider ? tableProvider.busy : false)},
			]"
		>
			<div class="p-3 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
				<span class="mr-2">{{ (tableProvider ? (tableProvider.state.perPage == -1 ? 'Todos de '+tableProvider.totalRows : (tableProvider.startRow > tableProvider.endRow ? tableProvider.endRow : tableProvider.startRow + ' - '+tableProvider.endRow+' de '+tableProvider.totalRows)) : '') }}</span>
				<feather-icon
					icon="ChevronDownIcon"
					svgClasses="h-4 w-4"
				/>
			</div>
			<vs-dropdown-menu :class="'con-vs-dropdown--menu vs-dropdown-menu '+ dropdownClass">
				<vs-dropdown-item
					:key="index"
					v-for="(option, index) in tableProvider.pageLengths"
					:disabled="backendOcupado || (tableProvider ? tableProvider.busy : false)"
					@click="$refs.dropdown.$el.click(); tableProvider.state.perPage = option.value;"
					:class="[
						{'bg-primary text-white': tableProvider.state.perPage == option.value},
					]"
				>
					<span>{{ (option.text == 'All' ? 'Todos' : option.text) }}</span>
				</vs-dropdown-item>
			</vs-dropdown-menu>
		</vs-dropdown>
	</div>
</template>
<script>
export default {
	name: "VsPaginationLengthCustom",
	props: {
		title: {
			type: String,
			default: "Paginação",
		},
		tableProvider: {
			type: Object,
			required: true,
		},
		backendOcupado: {
			type: Boolean,
			default: false,
			required: true,
		},
		dropdownClass: {
			type: String,
			default: "",
			required: false,
		},
	},
	data: () => ({}),
};
</script>
